import { render, staticRenderFns } from "./RespContent.vue?vue&type=template&id=2c1c496a"
import script from "./RespContent.vue?vue&type=script&lang=js"
export * from "./RespContent.vue?vue&type=script&lang=js"
import style0 from "./RespContent.vue?vue&type=style&index=0&id=2c1c496a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports